var render, staticRenderFns
import script from "./QuillEditor.vue?vue&type=script&lang=ts&"
export * from "./QuillEditor.vue?vue&type=script&lang=ts&"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&id=7d890d52&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports